'use client'
import React, { createContext, ReactNode, useState } from 'react'

type AccountContextProp = {
  children: ReactNode
}

type ContextType = {
  activeButton: string
  setActiveButton: (name: string) => void
  isSidebarOpen: boolean
  setIsSidebarOpen: (state: boolean) => void
  setIsGifting: (state: boolean) => void
  isGifting: boolean
}
const MyContext = createContext<ContextType | undefined>(undefined)

const AccountContext = ({ children }: AccountContextProp) => {
  const [activeButton, setActiveButton] = useState<string>('')
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)
  const [isGifting, setIsGifting] = useState<boolean>(false)
  return (
    <MyContext.Provider
      value={{
        activeButton,
        setActiveButton,
        isSidebarOpen,
        setIsSidebarOpen,
        setIsGifting,
        isGifting,
      }}
    >
      {children}
    </MyContext.Provider>
  )
}

export { AccountContext, MyContext }
